// extracted by mini-css-extract-plugin
export default {"container":"dUGMx","innerSize--full":"shsWg","content":"mvQM8","type--filled":"ANo7L"};